import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReminderPopupComponent } from './reminder-popup.component';

const routes: Routes = [{ path: '', component: ReminderPopupComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReminderPopupRoutingModule { }
